import {Ago} from '@github-ui/ago'
import {Label, Link} from '@primer/react'
import type {PackageResultItem, PackagesResults} from '../../types/blackbird-types'
import {Count} from '@github-ui/count'
import {DownloadIcon} from '@primer/octicons-react'
import Result from '../search-result'
import {packageIconFromName} from '../PackageIcons'
import {formatPackageTitle} from '../../utilities/format-type-title'
import styles from './Packages.module.css'

function Packages({results}: {results: PackagesResults}) {
  return (
    <Result.List>
      {results.results?.map((item, i) => (
        <PackageResult
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={i}
          item={item}
        />
      ))}
    </Result.List>
  )
}

function PackageResult({item}: {item: PackageResultItem}) {
  const updatedAt = new Date(item.updated_at)

  const repositoryName = item.repo.name
  const repositoryOwnerName = item.repo.owner_login
  const latestVersions = item.source.versions.filter(version => version.latest)
  const latestVersion = [...latestVersions].pop()?.version

  return (
    <Result>
      <Result.Header>
        {repositoryOwnerName && repositoryName && (
          <Result.RepositoryContext owner={repositoryOwnerName} name={repositoryName} />
        )}
        <span className="sr-only">:&nbsp;</span>
        <Result.Title>
          <Link href={item.package_url}>
            <span>{item.name}</span>
          </Link>
          {!item.public && <Label className={styles.visibilityLabel}>{item.source.visibility}</Label>}
        </Result.Title>
      </Result.Header>

      {item.summary && (
        <Result.Content>
          <span>{item.summary}</span>
        </Result.Content>
      )}

      <Result.Footer>
        <Result.FooterItem>
          {item.color && (
            <div className={styles.packageIconWrapper}>{packageIconFromName(item.source.package_type)}</div>
          )}
          {/* eslint-disable-next-line github/a11y-role-supports-aria-props */}
          <span aria-label={`${item.source.package_type} type`}>{formatPackageTitle(item.source.package_type)}</span>
        </Result.FooterItem>
        {latestVersion && (
          <Result.FooterItem>
            <span>{latestVersion}</span>
          </Result.FooterItem>
        )}
        <Result.FooterItem>
          <span className={styles.downloadIcon}>
            <DownloadIcon size={16} />
          </span>
          <Count ariaLabel={`${item.downloads} downloads`} value={item.downloads} />
        </Result.FooterItem>
        <Result.FooterItem>
          <span>
            Updated <Ago timestamp={updatedAt} />
          </span>
        </Result.FooterItem>
      </Result.Footer>
    </Result>
  )
}

export default Packages
